import { ApiHelper } from 'utils/apiHelper';

import { Environment } from 'Environment';
import * as CurrentUserTypes from 'reactApp/modules/CurrentUserModule/CurrentUserModule.types';

export const CurrentUserApi = {
    loadUser() {
        return ApiHelper.rpcCall<CurrentUserTypes.UserApiEntity>({
            url: 'user',
            returnRawResponse: true,
        });
    },

    editUser(data: CurrentUserTypes.EditUserParams) {
        return ApiHelper.rpcCall<CurrentUserTypes.UserApiEntity>({
            url: 'user',
            method: 'POST',
            data,
        });
    },

    signIn(data: CurrentUserTypes.SignInSignUpData) {
        const { email, password, captcha } = data;

        return ApiHelper.rpcCall<CurrentUserTypes.UserApiEntity>({
            url: 'auth/signin',
            method: 'POST',
            data: {
                email,
                password,
                captcha: captcha || undefined,
            },
        });
    },

    signUp(
        data:
            | CurrentUserTypes.SignInSignUpData
            | CurrentUserTypes.PartnerSignupData,
        params: CurrentUserTypes.SignUpParams = {},
    ) {
        let product_metrics;
        if (!Environment.isPrivateBuild) {
            product_metrics = {
                user_segment: 'A',
            };
        }

        return ApiHelper.rpcCall<CurrentUserTypes.UserApiEntity>({
            url: `auth/signup/${params.isPartner ? 'partner' : 'user'}`,
            method: 'POST',
            clearEmptyValues: true,
            data: {
                ...data,
                metrics: Environment.utmParams,
                product_metrics,
            },
        });
    },

    signOut() {
        return ApiHelper.rpcCall({
            url: 'auth/signout',
            method: 'POST',
        });
    },

    async sendPartnerRequest({
        company,
        name,
        phone,
        promocode,
    }: CurrentUserTypes.PartnerRequestData) {
        await ApiHelper.rpcCall({
            url: 'partner/invite/add',
            method: 'POST',
            data: { company, name, phone, promocode },
        });
    },

    editPassword: async ({
        captcha,
        new_password,
        password,
    }: CurrentUserTypes.PasswordChangeApiParams) =>
        ApiHelper.rpcCall({
            method: 'POST',
            url: 'user/password/change',
            data: { captcha: captcha || undefined, new_password, password },
        }),

    loadUserProjectsOSData() {
        return ApiHelper.rpcCall<CurrentUserTypes.UsersProjectsOS>({
            url: 'projects/services/infra',
        });
    },

    forward(email: string) {
        return ApiHelper.rpcCall({
            url: '/api/v1/user/verification/email/forward',
            method: 'POST',
            data: { email },
        });
    },

    confirm(code: string) {
        return ApiHelper.rpcCall<CurrentUserTypes.UserApiEntity>({
            url: '/api/v1/user/verification/email/confirm',
            method: 'POST',
            data: {
                code: code.replace(/[^A-z0-9]/g, ''),
            },
        });
    },
};
